import React from "react";
import Popup from "../../../Helpers/Popup/Popup";
import { Modal } from "react-bootstrap";
import PopupTitle from "../../../Helpers/Popup/PopupParts/PopupTitle";
import trans from "../../../../utils";
import { Tag } from "antd";
import Close from "../../../Helpers/CloseBtn/Close";
import InspectionRequestFormSubmission from "../../../InspectionRequest/InspectionRequestPopup/InspectionRequestFormSubmission";
import Loader from "../../../Helpers/Loader/Loader";

export default function IRContractorResubmission({
	setContAction,
	contAction,
	setIRId,
	irId,
	setAction,
	setTableData,
}) {
	return (
		<>
			<Popup show={contAction} size="lg">
				<Modal.Header className="modal-header flex-between">
					<Modal.Title id="contained-modal-title-vcenter">
						<PopupTitle
							headtitle={trans("Resubmit Form")}
							subtitle={<Tag color="orange">{irId?.ir_number || ""}</Tag>}
						/>
					</Modal.Title>
					<Close
						style="close-32 close"
						close={() => setContAction(false)}
						img="Close"
					/>
				</Modal.Header>
				<Modal.Body className="modal-body-scrollable fixed-popup-height">
					{irId?.formSchema?.fields ? (
						<InspectionRequestFormSubmission
							values={irId?.lastFormData || []}
							formFields={irId?.formSchema?.fields || []}
							resubmit={true}
							irId={irId}
							setContAction={setContAction}
							setTableData={setTableData}
						/>
					) : (
						<div className="text-center py-4">
							<Loader />
						</div>
					)}
				</Modal.Body>
			</Popup>
		</>
	);
}
